export const emotionList = [
    {
        emotion_id: 1,
        emotion_img: process.env.PUBLIC_URL + "/assets/emotion1.png",
        emotion_des: "Terrific",
    },
    {
        emotion_id: 2,
        emotion_img: process.env.PUBLIC_URL + "/assets/emotion2.png",
        emotion_des: "Happy",
    },
    {
        emotion_id: 3,
        emotion_img: process.env.PUBLIC_URL + "/assets/emotion3.png",
        emotion_des: "Moderate",
    },
    {
        emotion_id: 4,
        emotion_img: process.env.PUBLIC_URL + "/assets/emotion4.png",
        emotion_des: "Awful",
    },
    {
        emotion_id: 5,
        emotion_img: process.env.PUBLIC_URL + "/assets/emotion5.png",
        emotion_des: "Horrible",
    },
];
